import { restClient } from '../client';

export type ProviderEngagementOutput = {
  hasIdealCaseload: boolean;
  hasAtLeastFiveSpecialties: boolean;
  hasEnoughHours: boolean;
};

export const providerEngagementRequest = (_params: null) => restClient.request<ProviderEngagementOutput>('/api/v1/provider/engagement', {
  method: 'GET',
});
